import { Component, Input } from '@angular/core';
import { SETTINGS_TABLE_COLUMNS } from 'src/app/shared/constants/operationals';
import { NavigationService, SettingNavigationItem } from 'src/app/core/navigation.service';

@Component({
  selector: 'app-settings-data-table',
  templateUrl: './settings-data-table.component.html',
  styleUrls: ['./settings-data-table.component.scss'],
})
export class SettingsDataTableComponent {
  @Input() settings: SettingNavigationItem[] = [];
  displayed_columns: string[] = SETTINGS_TABLE_COLUMNS;

  constructor(private navigation_service: NavigationService) {}

  onProductCategoryClick(path: string): void {
    this.navigation_service.toGenericPath(path);
  }
}
